import apiUrl from "../../../constants"; // Import API URL constants
import commonFunction from "../../../commonFunction"; // Import common functions
import constantVariable from "../../../constantVariable"; // Import constant variables
import Vue from "vue"; // Import Vue framework
import axios from "axios"; // Import Axios for HTTP requests
import Paginate from "vuejs-paginate"; // Import Vue pagination component
import DatePicker from "vue2-datepicker"; // Import Vue datepicker component
import { ModelListSelect, BasicSelect } from "vue-search-select"; // Import search select components
import MultiSelect from "vue-multiselect"; // Import multi-select component
import "vue-multiselect/dist/vue-multiselect.min.css"; // Import styles for multi-select
import FileUpload from "v-file-upload"; // Import file upload component
import authFunction from "../../../authFunction"; // Import authentication functions
import moment from "moment"; // Import Moment.js for date formatting
import JQuery from "jquery"; // Import jQuery
let $ = JQuery; // Assign jQuery to $
Vue.use(FileUpload); // Enable FileUpload plugin
import Loading from "vue-loading-overlay"; // Import loading overlay component
import "vue-loading-overlay/dist/vue-loading.css"; // Import styles for loading overlay

// Register a global Vue filter for date formatting
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY hh:mm");
  }
});

export default {
  name: "ndr", // Component name
  components: {
    Paginate, // Pagination component
    DatePicker, // Datepicker component
    ModelListSelect, // Model list select component
    BasicSelect, // Basic select component
    Loading, // Loading overlay component
    MultiSelect, // Multi-select component
  },
  data() {
    return {
      ndrreport: [], // Array to store NDR report data
      searchClicked: false, // Flag to indicate search action
      isLoading: false, // Flag to show/hide loading overlay
      isLoadingPagination: false, // Flag for pagination loading
      fullPage: false, // Flag for full-page loading
      searchDate: null, // Selected search date
      format: "DD-MM-YYYY", // Date format
      endDate: new Date(), // Default end date
      page: "ndr", // Current page identifier
      ticketLabel: "Add Ticket", // Label for ticket actions
      contextType: [
        //#6175_ndr_verify Ndr reason list addition 
        {
          value: "Customer denied OTP based delivery",
          text: "Customer denied OTP based delivery",
        },
        {
          value: "Customer refused to accept",
          text: "Customer refused to accept",
        },
        {
          value: "Address incomplete", 
          text: "Address incomplete",
        },
        {
          value: "Customer not available", 
          text: "Customer not available",
        },
        {
          value: "Customer wants future delivery",
          text: "Customer wants future delivery",
        },
        {
          value: "Door step delivery not attempted", 
          text: "Door step delivery not attempted",
        },
        {
          value: "COD amount not ready", 
          text: "COD amount not ready",
        },
        {
          value: "Customer validation failure", 
          text: "Customer validation failure",
        },
        /*{
          value: "Customer not available at given address and not reachable over phone",
          text: "Customer not available at given address and not reachable over phone",
        },*/   //ndr reason not required 
        {
          value: "Entry not permitted", 
          text: "Entry not permitted",
        },
        {
          value: "Customer wants future pickup", 
          text: "Customer wants future pickup",
        },
        {
          value: "Pickup not attempted", 
          text: "Pickup not attempted",
        },
      ],
      contextTypeID: "", // Selected context type ID
      selectedContextTypeObj: {
        // Selected context type object
        value: "",
        text: "",
      },
    };
  },
  created: function () {
    // Placeholder for initialization code during component creation
  },
  computed: {
    // Placeholder for computed properties
  },
  filters: {
    moment: function (date) {
      // Filter to format date as DD-MM-YYYY
      if (!date) return;
      return moment(date).format("DD-MM-YYYY");
    },
    momentdate: function (date) {
      // Filter to format date as DD-MM-YYYY
      if (!date) return;
      return moment(date).format("DD-MM-YYYY");
    },
    momenttime: function (date) {
      // Filter to format time as HH:mm:ss
      if (!date) return;
      return moment(date).format("HH:mm:ss");
    },
  },
  mounted() {
    // Fetch user details and permissions during component mounting
    [
      this.subDepartmentList,
      this.DepartmentID,
      this.userdetail,
      this.permissiondata,
      this.userTypeForTicket,
      this.SummarySelectOptionObj,
      this.SummaryOptionObj,
    ] = commonFunction.getuserDetailsAndpermissionData();

    // Redirect if user is not in the NDR Dialer Team department
    if (this.DepartmentID !== constantVariable.NDR_Dialer_Team) {
      this.$router.push("/dashboard");
      this.$alertify.error("Please change department to NDR Dialer Team.");
    }
  },
  methods: {
    // Method to format a date as YYYY-MM-DD
    dateFormat1(date) {
      if (!date) return "";
      return moment(date).format("YYYY-MM-DD");
    },

    // Method to add one day to the date and format it as YYYY-MM-DD
    dateFormat2(date) {
      if (!date) return "";
      return moment(date).add(1, "d").format("YYYY-MM-DD");
    },

    // Method to reset the form inputs to their default values
    resetForm() {
      var self = this;
      this.searchDate = "";
      this.selectedContextTypeObj = {
        value: "",
        text: "",
      };
      this.contextTypeID = "";
      if (this.$refs.file) {
        this.$refs.file.value = null; // Clear the file input value
      }
    },

    // Method to handle selection of a context type from the dropdown
    selectedContextType(contextTypeData) {
      this.selectedContextTypeObj = contextTypeData;
      this.contextTypeID = contextTypeData.value;
    },

    // Method to handle file upload input validation
    handleFileUpload() {
      try {
        this.isLoading = true;
        this.file = this.$refs.file.files[0];
        if (
          ["csv"].indexOf(
            this.file.name.split(".")[this.file.name.split(".").length - 1]
          ) === -1
        ) {
          this.$alertify.error("Please upload file with .csv extensions.");
          document.getElementById("file").value = "";
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - handleFileUpload";
        this.$alertify.error(msg);
      }
    },

    // Method to upload a file along with additional form data
    uploadFile() {
      try {
        if (this.contextTypeID === "") {
          this.$alertify.error("Please select Context");
          return false;
        }
        if (document.getElementById("file").value == "") {
          this.$alertify.error("Please upload file with .csv extensions.");
          this.$refs.file.value = "";
          return false;
        }
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("contextTypeID", this.contextTypeID);
        axios({
          method: "POST",
          url: apiUrl.api_url + "ndr",
          data: formData,
          headers: commonFunction.getusertoken(),
        }).then(
          (result) => {
            this.isLoading = false;
            if (result.data.status == true) {
              this.$alertify.success(result.data.message);
            } else {
              this.$alertify.error(result.data.message);
            }
            this.resetForm();
          },
          (error) => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          }
        );
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - uploadFile";
        this.$alertify.error(msg);
      }
    },

    // Method to fetch NDR data based on the selected date
    getndrdata() {
      try {
        if (this.searchDate == null) {
          this.$alertify.error("Please select date.");
          return false;
        }
        this.input = {
          ReportDate: this.searchDate,
        };
        axios({
          method: "POST",
          url: apiUrl.api_url + "getndrata",
          data: this.input,
          headers: commonFunction.getusertoken(),
        }).then((result) => {
          this.isLoading = false;
          if (result.data.data.data === "") {
            console.log(result.data.data.status);
            this.$alertify.error(result.data.data.msg);
          } else {
            this.ndrreport = result.data.data.data;
          }
        });
      } catch (error) {
        let msg = error + " - getndrdata";
        this.$alertify.error(msg);
      }
    },

    // Method to download a sample CSV file
    sampleCSV() {
      try {
        let sampledata = [
          {
            ShippingID: "",
            Sequence: "",
          },
        ];
        let csv = "ShippingID,Sequence\n";
        sampledata.forEach((row) => {
          csv += row.ShippingID + ",";
          csv += row.Sequence + ",";
          csv += "\n";
        });
        const anchor = document.createElement("a");
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.target = "_blank";
        anchor.download = "samplecsv.csv";
        anchor.click();
        this.show = false;
        this.$alertify.success("Sample CSV is downloaded successfully");
      } catch (error) {
        this.$alertify.error("Error downloading Sample CSV");
      }
    },

    // Method to export NDR data to Excel file
    exportToExcel() {
      try {
        if (this.searchDate == null) {
          this.$alertify.error("Please select  date.");
          return false;
        } else {
          this.searchDate = moment(String(this.searchDate)).format(
            "YYYY-MM-DD"
          );
        }
        this.input = {
          ReportDate: this.searchDate,
        };

        axios({
          method: "POST",
          url: apiUrl.api_url + "exportNdrData",
          data: this.input,
          headers: commonFunction.getusertoken(),
          responseType: "blob", // important
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "AutoNDRReport.xlsx");
          document.body.appendChild(link);
          link.click();
        });
      } catch (error) {
        let msg = error + " - exportToExcel";
        this.$alertify.error(msg);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/ndr/ndr.component.js